import { useDomVisible } from './useDomVisible'
import { useMountedWatch } from './useMountedWatch'

export function useMutedProvider() {
  const muted = ref(true)
  provide('isMuted', muted)
  const toggleMuted = () => (muted.value = !muted.value)
  return { muted, toggleMuted }
}

export function useVideoActionInScroll(videoRef: Ref<any>, target: Ref<any>) {
  const isMuted = inject('isMuted') as Ref<boolean>
  // const isMuted = ref(false)
  const muted = ref(true)
  const targetIsVisible = useDomVisible(target, [0, 0.8])
  const loaded = ref(false)

  const videoCenter = useVideoCenter()

  watch(
    () => isMuted.value,
    (value) => {
      muted.value = value
    }
  )

  useMountedWatch(
    () => targetIsVisible.value,
    () => {
      if (targetIsVisible.value) {
        loaded.value = true
        videoCenter.value.forEach((item) => {
          if (item.value !== videoRef.value) {
            // item.value?.pause?.()
            if (item.value) {
              item.value?.pause?.()
            }
          }
        })

        if (videoRef.value) {
          videoRef.value.play?.()
        } else {
          nextTick(() => {
            videoRef.value?.play()
          })
        }
      } else {
        videoRef.value?.pause()
      }
    },
    { immediate: true }
  )

  onMounted(() => {
    if (videoCenter.value.includes(videoRef)) {
      return
    }

    videoCenter.value.push(videoRef)
  })

  onBeforeUnmount(() => {
    videoCenter.value = videoCenter.value.filter(
      (item) => item.value !== videoRef.value
    )
  })

  return { muted, targetIsVisible, loaded }
}
